// global auth state
import { reactive, readonly } from 'vue'
import jwt from 'vue-jwt-decode'
const keys = {
    stateStorageKey: 'state'
}

let appState = {
    auth: {
        isAuth: false, //default: false
        accessToken: null, //null
        accessTokenExp: false
    },
    user: {
        id: null, //null
        name: null, //null
        email: null, //null
        role: null, //null
        activeRole: null,
        image: null,
    }
}

let state = reactive(JSON.parse(localStorage.getItem(keys.stateStorageKey)) || appState);

const methods = {

    transformAndSetUser: async function (user) {
        if (!user?.accessToken) return;
        
        state.auth.accessToken = user.accessToken;
        try {
            const { id, name, email, role, image } = await jwt.decode(state.auth.accessToken);
            state.user.id = id;
            state.user.name = name;
            state.user.email = email;
            state.user.role = role;
            state.user.activeRole = (role[0]).toLowerCase()
            state.user.image = image
            state.auth.isAuth = true;
        } catch (error) {
            console.log(error);
        }

    },

    changeActiveRole: function (role) {
        if (!role) return;
        state.user.activeRole = role.toLowerCase();
    },

    saveState: function () {
        let stringifiedData = JSON.stringify(state);
        localStorage.setItem(keys.stateStorageKey, stringifiedData);
    },

    removeState: function () {
        localStorage.removeItem(keys.stateStorageKey);
        state.auth.isAuth = false;
        state.auth = {
            isAuth: false,
            accessToken: null,
            accessTokenExp: false,
        }
        state.user = {
            id: null,
            name: null,
            email: null,
            role: null,
            activeRole: null,
            image: null,
        }
    },
    changeImage: function (path) {
        if (!path || typeof path !== 'string') return new Error("Unexpected value, expected image path as param");
        state.user.image = path;
        this.saveState();
    }
}

export default {
    state: readonly(state),
    methods,
}

